import TRANSLATION_ACCESSIBILITY_VI from './accessibility/translation';
import TRANSLATION_BOOKING_VI from './booking/translation';
import TRANSLATION_EVENTS_VI from './events/translation';
import TRANSLATION_EXPERIENCES_VI from './experiences/translation';
import TRANSLATION_FORM_VI from './form/translation';
import TRANSLATION_LANDING_PAGES_VI from './landingPages/translation';
import TRANSLATION_RESERVE_VI from './reserve/translation';
import TRANSLATION_SIGNIN_VI from './signin/translation';
import TRANSLATION_DATES_VI from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_VI,
  ...TRANSLATION_BOOKING_VI,
  ...TRANSLATION_DATES_VI,
  ...TRANSLATION_EVENTS_VI,
  ...TRANSLATION_EXPERIENCES_VI,
  ...TRANSLATION_FORM_VI,
  ...TRANSLATION_LANDING_PAGES_VI,
  ...TRANSLATION_RESERVE_VI,
  ...TRANSLATION_SIGNIN_VI,
};
